import * as React from 'react';
import type { WebFragment } from 'state/persisted/connect-addon';
import type { ConnectFragmentLocation } from 'state/selectors/connect-addon';
import { ConnectFragmentDumb } from '../connect-fragment-dumb';
import { Root } from './styled';
import type { ErrorResponse } from 'epics/model/types';

export interface Props {
    connectFragments: WebFragment[] | { error: ErrorResponse } | undefined;
    className?: string;
    location: ConnectFragmentLocation;
}

const ConnectFragmentsDumb = ({ connectFragments, className, location }: Props) => {
    if (!connectFragments || 'error' in connectFragments) {
        return null;
    }

    if (connectFragments.length) {
        return (
            <Root className={className}>
                {connectFragments.map((fragment: WebFragment) => (
                    <ConnectFragmentDumb
                        key={fragment.key}
                        fullKey={fragment.key}
                        location={location}
                        fragmentHtml={fragment.html}
                    />
                ))}
            </Root>
        );
    }

    return null;
};

export default ConnectFragmentsDumb;
